import { Route } from '@angular/router';
import { InitialDataResolver } from './app.resolvers';
import {AuthGuard, LayoutComponent, NoAuthGuard} from "marida";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed in user
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},


    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('libs/marida/src/lib/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('libs/marida/src/lib/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            {path: 'confirmation-success', loadChildren: () => import('libs/marida/src/lib/auth/confirmation-success/confirmation-success.module').then(m => m.AuthConfirmationSuccessModule)},
            {path: 'confirmation-required', loadChildren: () => import('libs/marida/src/lib/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('libs/marida/src/lib/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'changepass', loadChildren: () => import('libs/marida/src/lib/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},

        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [

            {path: 'sign-out', loadChildren: () => import('libs/marida/src/lib/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('libs/marida/src/lib/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}

        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {path: 'users', loadChildren: () => import('libs/marida/src/lib/users/users.module').then(m => m.UsersModule)},
            {path: 'dashboard', loadChildren: () => import('libs/marida/src/lib/dashboard/project/project.module').then(m => m.ProjectModule)},
            {path: 'area-price', loadChildren: () => import('libs/marida/src/lib/area-price/area-price.module').then(m => m.AreaPriceModule)},
            {path: 'count-price', loadChildren: () => import('libs/marida/src/lib/count-price/count-price.module').then(m => m.CountPriceModule)},
            {path: 'service', loadChildren: () => import('libs/marida/src/lib/service/service.module').then(m => m.ServiceModule)},
            {path: 'calculation', loadChildren: () => import('libs/marida/src/lib/calculation/calculation.module').then(m => m.CalculationModule)},
            {path: 'customer', loadChildren: () => import('libs/marida/src/lib/customer/customer.module').then(m => m.CustomerModule)},
            {path: 'support', loadChildren: () => import('libs/marida/src/lib/pages/support/support.module').then(m => m.SupportModule)},
            {path: 'changelog', loadChildren: () => import('libs/marida/src/lib/pages/changelog/changelog.module').then(m => m.ChangelogModule)},
            {path: 'profile', loadChildren: () => import('libs/marida/src/lib/profile/profile.module').then(m => m.ProfileModule)},

            // maintenance, error & Catch all
            {path: 'maintenance', loadChildren: () => import('libs/marida/src/lib/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule)},
            {path: '500-internal-server-error', loadChildren: () => import('libs/marida/src/lib/pages/error/error-500/error-500.module').then(m => m.Error500Module)},
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('libs/marida/src/lib/pages/error/error-404/error-404.module').then(m => m.Error404Module)},
            {path: '**', redirectTo: '404-not-found'}
        ]
    }
];
